import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { doctorsApi, type DoctorDocument, type DocumentType } from '@/api';

export const DOCTOR_DOCUMENTS_KEY = ['doctor', 'documents'] as const;

export function useDoctorDocuments() {
  return useQuery({
    queryKey: DOCTOR_DOCUMENTS_KEY,
    queryFn: async () => {
      try {
        const res = await doctorsApi.getMyDocuments();
        if (Array.isArray(res)) return res as DoctorDocument[];
        if (res && Array.isArray((res as any).documents)) return (res as any).documents as DoctorDocument[];
        if (res && Array.isArray((res as any).data)) return (res as any).data as DoctorDocument[];
        return [] as DoctorDocument[];
      } catch (err) {
        console.warn('Failed to fetch doctor documents:', err);
        return [] as DoctorDocument[];
      }
    },
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
}

export function useUploadDoctorDocument() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (data: { type: DocumentType; fileUrl: string }) =>
      doctorsApi.uploadDocument(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: DOCTOR_DOCUMENTS_KEY });
    },
  });
}

export function useDeleteDoctorDocument() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => doctorsApi.deleteDocument(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: DOCTOR_DOCUMENTS_KEY });
    },
  });
}
